<script>
import { navComputed } from '@state/helpers'
import HrItemGroup from './../../safehaven/hr-item-group.vue'
export default {
  components: {
    HrItemGroup,
    SymptomcheakerEditor: () =>
      import(
        '@/src/router/views/health-record/editors/symptom-cheaker-editor.vue'
      ),
    AllergyEditor: () =>
      import('@/src/router/views/health-record/editors/allergy-editor.vue'),
    ConditionEditor: () =>
      import('@/src/router/views/health-record/editors/condition-editor.vue'),
    SymptomEditor: () =>
      import('@/src/router/views/health-record/editors/symptom-editor.vue'),
    ProcedureEditor: () =>
      import('@/src/router/views/health-record/editors/procedure-editor.vue'),
    SurgeryEditor: () =>
      import('@/src/router/views/health-record/editors/surgery-editor.vue'),
    MedicationEditor: () =>
      import('@/src/router/views/health-record/editors/medication-editor.vue'),
    SupplimentEditor: () =>
      import('@/src/router/views/health-record/editors/suppliment-editor.vue'),
    ImmunizationEditor: () =>
      import(
        '@/src/router/views/health-record/editors/immunization-editor.vue'
      ),
    FamilyHistoryEditor: () =>
      import(
        '@/src/router/views/health-record/editors/family-history-editor.vue'
      ),
    SocialHistoryEditor: () =>
      import(
        '@/src/router/views/health-record/editors/social-history-editor.vue'
      ),
    TravelHistoryEditor: () =>
      import(
        '@/src/router/views/health-record/editors/travel-history-editor.vue'
      ),
    MedicalVisitEditor: () =>
      import(
        '@/src/router/views/health-record/editors/medical-visit-editor.vue'
      ),
    DiagnosticsEditor: () =>
      import('@/src/router/views/health-record/editors/diagnostics-editor.vue'),

    LabsEditor: () =>
      import('@/src/router/views/health-record/editors/labs-editor.vue'),
  },
  props: {
    // preselected group for using inside views (e.g Medical History should preselect its group)
    group: {
      type: Number,
      default: 0,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    create: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: Object,
      default: Object,
    },
    item: {
      type: Object,
      default: null,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    avatarButton: {
      type: Boolean,
      default: false,
    },
    btnType: {
      type: Boolean,
      require: false,
    },
  },
  data() {
    return {
      editorEnabled: false,
      formSaved: false,
      formSavedAnother: false,
      formChanged: false,
      snackbar: false,
      snackbarMessage: '',
      selected: null,
      groupProp: null,
      attachmentDeleted: false,
    }
  },
  computed: {
    ...navComputed,
    openRightSideDrawer() {
      return this.calendarDrawer || this.settingsDrawer
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
  },
  watch: {
    formSaved(newValue, oldValue) {
      if (newValue) {
        this.editorEnabled = false
        this.$emit('form-saved', this.selected)
        this.snackbar = true
        this.snackbarMessage = this.selected
          ? this.$t(this.selected.message_translate)
          : ''
        this.selected = null
        this.formSaved = false
      }
    },
    formSavedAnother(newValue, oldValue) {
      if (newValue) {
        this.$emit('form-saved', this.selected)
        this.snackbar = true
        this.snackbarMessage = this.selected
          ? this.$t(this.selected.message_translate)
          : ''
        this.formSavedAnother = false
      }
    },
    attachmentDeleted(newValue, oldValue) {
      if (newValue) {
        this.$emit('form-saved', this.selected)
        this.attachmentDeleted = false
      }
    },
    create: {
      handler(newVal) {
        this.editorEnabled = newVal
      },
      immediate: true,
    },
    edit: {
      handler(newVal) {
        this.editorEnabled = newVal
      },
      immediate: true,
    },
    menu: {
      handler(newVal) {
        if (newVal) {
          this.selected = newVal
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.groupProp = this.group
  },
  methods: {
    selectSection(event, item) {
      if (this.selected.key === 'SYMPTOM_CHEAKER') {
        this.$router.push({
          name: 'safehaven-symptom-checker',
        })
      } else {
        this.editorEnabled = true
      }
    },
    closeDialog() {
      this.$emit('update:menu', null)
      this.$emit('update:item', null)
      this.$emit('update:edit', false)
      this.$emit('update:create', false)
      this.$emit('update:dialog', false)
      setTimeout(() => {
        this.editorEnabled = false
      }, 500)
    },
    selectEvent(card) {
      this.selected = card
    },
    scrollTop() {
      this.$vuetify.goTo(this.$refs.top, {
        container: this.$refs.card,
        duration: 800,
        easing: 'easeInOutCubic',
      })
    },
    deleteFromHr(resource) {
      this.$emit('delete-from-hr', resource)
    },
    backToHRMenu() {
      this.selected = null
      this.editorEnabled = false
    },
  },
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      :fullscreen="mobile"
      persistent
      no-click-animation
      overlay-color="body"
      overlay-opacity="0.6"
      min-width="300px"
      max-width="1100px"
      scrollable
      transition="fade-transition"
      :content-class="'elevation-0' + ' ' + $style.dialogMenu"
    >
      <v-card color="offwhite" min-height="550">
        <v-card-title style="padding: 10px 24px 0 !important">
          <v-row class="" no-gutters>
            <div
              v-if="!edit && editorEnabled"
              class="ml-3 clickable primary--text"
              :class="$style.hrRouterLinkText"
              @click="backToHRMenu"
            >
              <v-icon color="primary"> mdi-chevron-left </v-icon> Back
            </div>
            <v-spacer></v-spacer>
            <v-btn color="offblack" icon @click="closeDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-row>
        </v-card-title>
        <v-card-text id="componentArea" ref="card" :class="$style.cardText">
          <!-- close button -->
          <div ref="top"></div>

          <!-- editor -->
          <component
            :is="selected ? selected.editor : ''"
            v-if="editorEnabled"
            :form-changed.sync="formChanged"
            :form-saved.sync="formSaved"
            :form-saved-another.sync="formSavedAnother"
            :attachment-deleted.sync="attachmentDeleted"
            :edit="edit"
            :item="item"
            @add-another="scrollTop"
            @back="editorEnabled = false"
            @close-dialog="closeDialog"
            @delete-from-hr="deleteFromHr"
          ></component>

          <!-- card dialog -->
          <template v-else>
            <!-- title, subtitle -->
            <v-row no-gutters :class="$style.title">
              What type of record would you like to add?
            </v-row>

            <HrItemGroup
              :group="groupProp"
              @select-changed="selectEvent"
            ></HrItemGroup>

            <!-- submit button -->
            <v-row class="mt-2 mb-3" style="justify-content: center">
              <v-btn
                class="primary-btn"
                elevation="0"
                width="236"
                height="50"
                @click="selectSection($event, selected)"
                >Start</v-btn
              >
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- hr/sc fab -->

    <v-btn
      v-if="btnType"
      class="primary-btn"
      @click="$emit('update:dialog', true)"
    >
      Add Record
    </v-btn>
    <a v-else @click="$emit('update:dialog', true)"> Add a health record </a>

    <!-- notification snackbar -->
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="5000"
    >
      <div class="d-flex">
        <v-icon color="#81C784" class="my-auto">mdi-check-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.fabButton {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
}

.fabButtonOffset {
  background: rgb(15, 94, 249);
  background: linear-gradient(
    90deg,
    rgba(15, 94, 249, 1) 0%,
    rgba(47, 236, 230, 1) 100%
  );
  transform: translateX(-300px);
}

.dialogMenu {
  max-height: 90% !important;
  overflow-y: clip !important;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none;
}

.dialogMenu::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.title {
  display: block;
  font-size: 22px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  color: #454648 !important;
  text-align: center;
}

.subTitle {
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 1px;
}
.cardText {
  /* width */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    margin-top: 5px;
    margin-bottom: 5px;
    background: $color-theme-light-input;
    border-radius: 15px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: $color-theme-light-line;
    border-radius: 15px;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: $color-theme-light-placehold;
  }

  &::-webkit-scrollbar-thumb:active {
    background: $color-theme-light-label;
  }
}

.hrRouterLinkText {
  font-family: $system-default-font-family;
  font-size: 20px;
}

@media screen and (max-width: 960px) {
  .dialogMenu {
    max-height: 100% !important;
    padding-bottom: 2px;
  }
}
</style>
